module.exports = __webpack_public_path__ + "assets/selectedImg.9e09403a51523a718fe691a7cd90288b.png";